/* eslint-disable */
import React, { useState, useEffect, useMemo } from "react";
import Sidebar from "../../../components/worker/sidebar/SidebarWorker";
import Navbar from "../../../components/worker/navbar/Navbar2";
import Footer from "../../../components/worker/footer/Footer";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import {
  UserCircle,
  CreditCard,
  Settings,
  Truck,
  Globe,
  Share2,
  Boxes,
  Building2,
  PackageCheck,
  Calendar,
  Layout,
  Users,
  HeartHandshake,
  School,
  MessageCircle,
} from "lucide-react";
import { useTranslation } from "react-i18next";

function WorkerSettingsPage() {
  const account = useSelector((state) => state.AccountReducer);
  const worker = useSelector((state) => state.workerReducer);
  console.log("Worker data in WorkerSettingsPage:", worker);
  const [showSideBar, setShowSideBar] = useState(true);
  const [activeSection, setActiveSection] = useState(-1);
  const { t, i18n } = useTranslation();

  const allSections = [
    {
      title: t("settings.account_settings"),
      icon: <UserCircle className="text-[#9e68ba]" size={20} />,
      cards: [
        {
          link: "/team/settings/account",
          digitalLink: "/settings/account",
          icon: <UserCircle size={28} className="text-[#9e68ba]" />,
          title: t("settings.account_settings_card"),
          description: t("settings.account_settings_description"),
        },
        {
          link: "/subscription",
          digitalLink: "/subscription",
          icon: <CreditCard size={28} className="text-[#9e68ba]" />,
          title: t("settings.subscription_management"),
          description: t("settings.subscription_management_description"),
        },
      ],
    },
    {
      title: t("settings.initial_settings"),
      icon: <Settings className="text-[#9e68ba]" size={20} />,
      cards: [
        {
          link: "/settings/form",
          digitalLink: "/digital/settings/form",
          icon: <Layout size={28} className="text-[#9e68ba]" />,
          title: t("settings.form_settings"),
          description: t("settings.form_settings_description"),
        },
        {
          link: "/settings/store",
          digitalLink: "/digital/settings/store",
          icon: <Building2 size={28} className="text-[#9e68ba]" />,
          title: t("settings.store_design_options"),
          description: t("settings.store_design_options_description"),
        },
        {
          link: "/settings/OrderSettings",
          digitalLink: "/digital/settings/OrderSettings",
          icon: <PackageCheck size={28} className="text-[#9e68ba]" />,
          title: t("settings.fake_orders_settings"),
          description: t("settings.fake_orders_settings_description"),
          hideInNonClassic: true,
        },
        {
          link: "/settings/delevery",
          digitalLink: "/settings/delevery",
          icon: <Truck size={28} className="text-[#9e68ba]" />,
          title: t("settings.shipping_delivery_prices"),
          description: t("settings.shipping_delivery_prices_description"),
          hideInNonClassic: true,
        },
        {
          link: "/domains",
          digitalLink: "/digital/domains",
          icon: <Globe size={28} className="text-[#9e68ba]" />,
          title: t("settings.store_domain"),
          description: t("settings.store_domain_description"),
        },
        {
          link: "/settings/SocialMedia",
          digitalLink: "/digital/settings/SocialMedia",
          icon: <Share2 size={28} className="text-[#9e68ba]" />,
          title: t("settings.social_media_working_hours"),
          description: t("settings.social_media_working_hours_description"),
        },
      ],
    },
    {
      title: t("settings.advanced_settings"),
      icon: <Boxes className="text-[#9e68ba]" size={20} />,
      cards: [
        {
          link: "/settings/shipcollect",
          digitalLink: "/settings/shipcollect",
          icon: <Truck size={28} className="text-[#9e68ba]" />,
          title: t("settings.delivery_company_integration"),
          description: t("settings.delivery_company_integration_description"),
          hideInNonClassic: true,
        },
        {
          link: "/settings/services",
          digitalLink: "/digital/settings/services",
          icon: <Settings size={28} className="text-[#9e68ba]" />,
          title: t("settings.services_integration"),
          description: t("settings.services_integration_description"),
        },
        {
          link: "/settings/Country-Currency",
          digitalLink: "/digital/settings/currency",
          icon: <CreditCard size={28} className="text-[#9e68ba]" />,
          title: t("settings.payment_country_settings"),
          description: t("settings.payment_country_settings_description"),
        },
        {
          link: "/settings/footer",
          digitalLink: "/digital/settings/footer",
          icon: <Layout size={28} className="text-[#9e68ba]" />,
          title: t("settings.footer_settings"),
          description: t("settings.footer_settings_description"),
        },
        {
          link: "/adduser",
          digitalLink: "/adduser",
          icon: <Users size={28} className="text-[#9e68ba]" />,
          title: t("settings.add_confirmers"),
          description: t("settings.add_confirmers_description"),
          hideInNonClassic: true,
        },
        {
          link: "/settings/stock",
          digitalLink: "/settings/stock",
          icon: <Boxes size={28} className="text-[#9e68ba]" />,
          title: t("settings.inventory_settings"),
          description: t("settings.inventory_settings_description"),
          hideInNonClassic: true,
        },
      ],
    },
    {
      title: t("settings.educational_support"),
      icon: <HeartHandshake className="text-[#9e68ba]" size={20} />,
      cards: [
        {
          link: "https://m.me/F0orweb",
          digitalLink: "https://m.me/F0orweb",
          icon: <MessageCircle size={28} className="text-[#9e68ba]" />,
          title: t("settings.help_center"),
          description: t("settings.help_center_description"),
          isExternal: true,
        },
        {
          link: "https://t.me/+PA1piqOcr2AyMjY0",
          digitalLink: "https://t.me/+PA1piqOcr2AyMjY0",
          icon: <School size={28} className="text-[#9e68ba]" />,
          title: t("settings.foorweb_academy"),
          description: t("settings.foorweb_academy_description"),
          isExternal: true,
        },
        {
          link: "https://khabir.foorweb.net",
          digitalLink: "https://khabir.foorweb.net",
          icon: <Calendar size={28} className="text-[#9e68ba]" />,
          title: t("settings.consulting_sessions"),
          description: t("settings.consulting_sessions_description"),
          isExternal: true,
        },
      ],
    },
  ];

  const sections = useMemo(() => {
    const isClassicMode = (account?.productMode ?? "classic") === "classic";

    if (isClassicMode) {
      return allSections;
    }
    return allSections
      .map((section) => ({
        ...section,
        cards: section.cards.filter((card) => !card.hideInNonClassic),
      }))
      .filter((section) => section.cards.length > 0);
  }, [t, i18n.language, account?.productMode]);

  // Fonction pour déterminer le lien à utiliser
  const getCardLink = (card) => {
    const isClassicMode = (account?.productMode ?? "classic") === "classic";
    return isClassicMode ? card.link : card.digitalLink;
  };

  useEffect(() => {
    function handleResize() {
      setShowSideBar(window.innerWidth > 1080);
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClick = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div
      className="container-fluid bg-gradient-to-br from-white to-purple-50 min-h-screen dark:!bg-[#141414]"
      dir={t("settings.direction")}
    >
      <div className="row mb-10">
        {showSideBar && (
          <div style={{ width: "250px", flexShrink: 0 }}>
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div
          className="px-3 relative min-h-[100vh] dark:!bg-[#141414]"
          style={{ flex: 1, backgroundColor: "#fbf8fc" }}
        >
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />

          <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 m-3 mt-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <h2 className="text-xl font-bold text-[#9e68ba] mb-1">
                  {t("settings.settings_center")}
                </h2>
                <p className="text-gray-600 dark:!text-gray-300 mb-0">
                  {t("settings.settings_center_description")}
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm border border-[#fbf4ff] dark:!border-[#3c3a3d] mx-3 mb-4 overflow-auto">
            <div className="flex overflow-x-auto scrollbar-hide">
              <button
                className={`flex items-center px-6 py-3 whitespace-nowrap transition-colors ${
                  activeSection === -1
                    ? "text-[#9e68ba] border-b-2 border-[#bc7ade] bg-[#fcf6ff] dark:!bg-[#6e358c] dark:!text-gray-400 font-medium"
                    : "text-gray-600 hover:bg-[#6e358c] hover:bg-[#fcf6ff] dark:hover:bg-[#c06bed] dark:!text-gray-500"
                }`}
                onClick={() => setActiveSection(-1)}
              >
                <span className="ml-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#9e68ba"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-layout-grid-icon lucide-layout-grid"
                  >
                    <rect width="7" height="7" x="3" y="3" rx="1" />
                    <rect width="7" height="7" x="14" y="3" rx="1" />
                    <rect width="7" height="7" x="14" y="14" rx="1" />
                    <rect width="7" height="7" x="3" y="14" rx="1" />
                  </svg>
                </span>
                {t("settings.all")}
              </button>
              {sections.map((section, index) => (
                <button
                  key={index}
                  className={`flex items-center px-6 py-3 whitespace-nowrap transition-colors ${
                    activeSection === index
                      ? "text-[#9e68ba] border-b-2 border-[#bc7ade] bg-[#fcf6ff] font-medium dark:!bg-[#6e358c] dark:!text-gray-400"
                      : "text-gray-600 hover:bg-[#fcf6ff] dark:hover:bg-[#c06bed]"
                  }`}
                  onClick={() => setActiveSection(index)}
                >
                  <span className="ml-2">{section.icon}</span>
                  {section.title}
                </button>
              ))}
            </div>
          </div>

          <div className="p-3 space-y-8">
            {activeSection === -1 ? (
              sections.map((section, index) => (
                <div key={index}>
                  <div className="flex justify-start mb-2">
                    <h3 className="text-xl font-semibold text-[#9e68ba]">
                      {section.title}
                    </h3>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {section.cards.map((card, cardIndex) => (
                      <Link
                        key={cardIndex}
                        to={card.isExternal ? undefined : getCardLink(card)}
                        onClick={
                          card.isExternal
                            ? () => handleClick(getCardLink(card))
                            : undefined
                        }
                        className="block"
                      >
                        <div className="bg-white dark:!bg-[#181819] h-[100px] rounded-xl border border-[#fbf4ff] dark:!border-[#3c3a3d] shadow-sm overflow-hidden hover:shadow-md hover:border-purple-200 transition-all">
                          <div
                            className={`flex p-4 h-full items-center ${
                              i18n.language === "ar" ? "flex-row" : "flex"
                            }`}
                          >
                            <div className="bg-[#fcf6ff] dark:!bg-[#181819] p-3 rounded-lg flex items-center justify-center w-14 h-14 mx-4">
                              {card.icon}
                            </div>
                            <div className="flex flex-col justify-between h-[90px] py-4">
                              <h3 className="font-bold text-xl text-[#9e68ba] mb-1">
                                {card.title}
                              </h3>
                              <p className="text-gray-600 text-sm">
                                {card.description}
                              </p>
                            </div>
                          </div>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              ))
            ) : (
              <div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  {sections[activeSection].cards.map((card, cardIndex) => (
                    <Link
                      key={cardIndex}
                      to={card.isExternal ? undefined : getCardLink(card)}
                      onClick={
                        card.isExternal
                          ? () => handleClick(getCardLink(card))
                          : undefined
                      }
                      className="block"
                    >
                      <div className="bg-white dark:!bg-[#181819] h-[100px] rounded-xl border border-[#fbf4ff] dark:!border-[#3c3a3d] shadow-sm overflow-hidden hover:shadow-md hover:border-purple-200 transition-all">
                        <div className="flex p-4 h-full items-center">
                          <div className="bg-[#fcf6ff] dark:!bg-[#181819] p-3 rounded-lg ml-4 flex items-center justify-center w-14 h-14">
                            {card.icon}
                          </div>
                          <div className="flex flex-col justify-between h-[90px] py-4">
                            <h3 className="font-bold text-xl text-[#9e68ba] mb-1">
                              {card.title}
                            </h3>
                            <p className="text-gray-600 text-sm">
                              {card.description}
                            </p>
                          </div>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div className="bottom-0">
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
}

export default WorkerSettingsPage;
